export default "__VITE_ASSET__CIWHMAiP__"